module.exports = __webpack_public_path__ + "static/media/certificado.e2598d31.svg";